import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { ResourceLinkedProviderViewModel } from '../models/resources';

@Injectable({
  providedIn: 'root'
})
export class ResourceDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getResourceOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('resources/options', request, cancellationToken);
  }

  getResourceOptionsByClinicAsync(clinicId: number, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: any = { clinicId: clinicId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('resources/OptionsByClinic', request, cancellationToken);
  }

  checkResourceClinicExistsAsync(resourceId: number, clinicId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { clinicId: clinicId, resourceId: resourceId, id: id };
    return this.httpClient.getJsonAsync<boolean>('resourceClinics/checkLinkExists', data, timeout, false);
  }

  getResourceLinkedProviderAsync(resourceId: number, timeout: Promise<any>): Promise<ResourceLinkedProviderViewModel> {
    const data = { resourceId };
    return this.httpClient.getJsonAsync<ResourceLinkedProviderViewModel>('Resources/GetResourceLinkedProvider', data, timeout, false);
  }
}
